<div class="backend-down-container">
  <div class="error-content">
    <div class="error-icon">
      <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    <h1 class="error-title">Backend API is Down</h1>
    <p class="error-message">
      We're sorry, but our backend services are currently unavailable.
      This might be due to maintenance or a temporary network issue.
    </p>
    <p class="error-details">
      Please try again in a few moments. If the problem persists, contact your system administrator.
    </p>
    <button class="retry-button" (click)="retry()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
      </svg>
      Retry Connection
    </button>
  </div>
</div>
